import { AddressFieldInfo } from "./address-field-info.class";

export class AddressLine {
    fields: AddressFieldInfo[] = [];
}
